/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cl_ForbiddenInputs */

const en_cl_forbidden = /** @type {(inputs: Cl_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only product admins can change the content language.`)
};

const de_cl_forbidden = /** @type {(inputs: Cl_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Produktadmins können die Inhaltssprache ändern.`)
};

/**
* | output |
* | --- |
* | "Only product admins can change the content language." |
*
* @param {Cl_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cl_forbidden = /** @type {((inputs?: Cl_ForbiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cl_ForbiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cl_forbidden(inputs)
	return en_cl_forbidden(inputs)
});